import { Redirect } from 'expo-router'

/**
 * Forms moved onto the Care tab. This stands in for the old link.
 *
 * It is a route rather than a `redirects` entry in app.config because that config matched
 * `/forms` as a prefix and swallowed `/forms/123` with it, so opening a form pushed straight
 * back to Care. A route file matches the path exactly.
 */
export default function FormsIndex() {
	return <Redirect href="/care" />
}
